import React, { ButtonHTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';
import { Link, InertiaLinkProps } from '@inertiajs/react';

type ButtonStyle = 'filled' | 'tonal' | 'outline' | 'text';

export type ButtonProps = {
    as?: 'button' | string,
    buttonStyle?: ButtonStyle;
} & ButtonHTMLAttributes<HTMLButtonElement>;

export type LinkButtonProps = {
    as?: 'Link' | string,
    buttonStyle?: ButtonStyle;
} & InertiaLinkProps;

const ButtonStyles: Record<ButtonStyle, string> = {
    filled: 'bg-primary text-on-primary hover:bg-primary/80 focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-surface-1',
    tonal: 'bg-primary-container text-on-primary-container hover:bg-primary-container/80 focus:ring-2 focus:ring-primary-container/50 focus:ring-offset-2 focus:ring-offset-surface-1',
    outline: 'border border-primary text-primary hover:bg-primary/10 focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-surface-1',
    text: 'text-primary hover:bg-primary/10 focus:ring-2 focus:ring-primary/50 focus:ring-offset-2 focus:ring-offset-surface-1'
};

const ButtonComponent = ({ as = 'button', buttonStyle = 'filled', className, children, ...rest }: ButtonProps) => {
    return React.createElement(as, {
        ...rest,
        className: twMerge(
            'rounded-lg px-4 py-2 font-medium pointer-cursor size-auto text-center',
            ButtonStyles[buttonStyle],
            className
        )
    }, children);
};

export const LinkButton = ({ as = 'Link', buttonStyle = 'filled', className, children, ...rest }: LinkButtonProps) => {
    return (
        <Link
            {...rest}
            as={as === 'Link' ? undefined : as}
            className={twMerge(
                'rounded-lg px-4 py-2 font-medium pointer-cursor size-auto text-center',
                ButtonStyles[buttonStyle],
                className
            )}>
            {children}
        </Link>
    )
};

export const Button = Object.assign(ButtonComponent, {
    Link: LinkButton,
})
